import { CloudStagingListNirvanaDataProvider } from '../dataProvider/CloudStagingListNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class CloudStagingListDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, CloudStagingListNirvanaDataProvider);
  }
}
